import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import Form from '@afosto/app-components-react/Form';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Checkbox from '@afosto/app-components-react/Checkbox';
import TextField from '@afosto/app-components-react/TextField';
import translations from './translations';
import validationSchema from './validations';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import SECONDS_IN_A_DAY from '../../utils/constants';

const CouponCategoryForm = ({
  isEditing,
  inline,
  category,
  onSubmit,
  onCancel,
  onEdit,
  readOnly,
}) => {
  const intl = useIntl();

  const form = useForm({
    validationSchema,
    isEditing,
    editInline: inline,
    defaultValues: {
      name: category?.name ?? '',
      expiresAfter: category?.defaults?.expires_after / SECONDS_IN_A_DAY ?? 5,
      isUnlimited: category?.defaults?.usage?.is_unlimited ?? false,
      limit: category?.defaults?.usage?.limit ?? '',
    },
    onSubmit,
    onCancel,
  });
  const { watch } = form;
  const isUnlimitedValue = watch('isUnlimited');

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <TextField
          name="name"
          label={intl.formatMessage(translations.fields.name.label)}
          onEdit={onEdit}
          readOnly={readOnly}
        />
        <Typography variant="button" component="div" style={{ marginTop: 24 }}>
          <FormattedMessage {...translations.fields.defaultSettings.label} />
        </Typography>
        <TextField
          name="expiresAfter"
          type="number"
          label={intl.formatMessage(translations.fields.expiresAfter.label)}
          onEdit={onEdit}
          readOnly={readOnly}
        />
        <Checkbox
          name="isUnlimited"
          label={intl.formatMessage(translations.fields.isUnlimited.label)}
          onEdit={onEdit}
          readOnly={readOnly}
        />
        {!isUnlimitedValue && (
          <TextField
            name="limit"
            label={intl.formatMessage(translations.fields.limit.label)}
            onEdit={onEdit}
            readOnly={readOnly}
            type="number"
          />
        )}
      </Form>
    </LoadingWrapper>
  );
};

CouponCategoryForm.propTypes = {
  category: PropTypes.object,
  inline: PropTypes.bool,
  isEditing: PropTypes.bool,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func,
  onSubmit: PropTypes.func,
  readOnly: PropTypes.bool,
};

CouponCategoryForm.defaultProps = {
  category: undefined,
  inline: false,
  isEditing: false,
  onCancel: undefined,
  onEdit: undefined,
  onSubmit: undefined,
  readOnly: false,
};

export default CouponCategoryForm;
